<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="6">
        <evaluado-info-card-component :expediente="expediente[0]" />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        offset="3"
      >
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title class="font-weight-bold justify-center">
            Validación ISE
          </v-card-title>
          <v-card-text>
            <v-container class="mb-4">
              <v-row align="center">
                <v-col
                  cols="4"
                  align="center"
                >
                  <v-progress-circular
                    :value="activeStep * 33.3"
                    v-bind="circularProgressProps"
                  />
                </v-col>
                <v-col cols="8">
                  <div class="text-caption text--primary">
                    PASO {{ activeStep }}
                  </div>
                  <div class="text-subtitle-1 font-weight-bold text--primary">
                    {{ activeStepTitle }}
                  </div>
                  <a
                    v-show="activeStep !== 1"
                    class="text-decoration-none secondary--text"
                    @click="activeStep--"
                    @keydown="activeStep--"
                  >Volver al paso anterior</a>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep === 1">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="validacion.oficioValidacion"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Número de oficio de solicitud de documento escolar"
                  />
                </v-col>
                <v-col
                  cols="12"
                  align="center"
                >
                  <div class="text-subtitle-2 font-weight-bold">
                    Fecha de solicitud de validación
                  </div>
                  <v-date-picker
                    v-model="validacion.fechaOficio"
                    locale="es"
                    color="secondary"
                    no-title
                    full-width
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else-if="activeStep === 2">
              <v-form v-model="resultadoForm">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="validacion.matriculaCartilla"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Matrícula de cartilla SMN"
                    />
                    <v-textarea
                      v-model="validacion.resultado"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Resultado"
                      no-resize
                      rows="3"
                    />
                    <v-textarea
                      v-model="validacion.observaciones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Observaciones"
                      no-resize
                      rows="3"
                    />
                    <v-file-input
                      v-model="file"
                      label="Oficio de solicitud de cartilla"
                      rounded
                      filled
                      background-color="primary"
                      color="secondary"
                      dense
                      prepend-icon="mdi-file"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="validacion.fk_idCatSemaforoResultado"
                      label="Semáforo de resultado"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="semaforoResultado"
                      item-value="id"
                      item-text="nombre"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container>
              <v-row>
                <v-col
                  md="12"
                  align="center"
                >
                  <v-btn
                    rounded
                    class="mx-8"
                    elevation="8"
                    color="secondary"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    @click="activeStepButtonHandler"
                  >
                    {{ activeStepButtonLabel }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      color="secondary"
      opacity="1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { circularProgressProps } from '../../components/props/props';
import EvaluadoInfoCardComponent from '../../components/EvaluadoInfoCardComponent.vue';

export default {
  name: 'ValidacionView',
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    idDerivacion: {
      type: Number,
      required: true,
    },
    idProgramacion: {
      type: Number,
      required: true,
    },
    idExpediente: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      circularProgressProps,

      loading: false,
      resultadoForm: false,
      overlay: false,

      activeStep: 1,

      validacion: {
        fk_idDerivacion: this.idDerivacion,
        fk_idProgramacion: this.idProgramacion,
        fk_idExpediente: this.idExpediente,
        fechaElaboracion: moment().format('DD/MM/YYYY'),
        fechaEvaluacion: null,
        oficioValidacion: '',
        fechaOficio: null,
        matriculaCartilla: '',
        resultado: '',
        observaciones: '',
        adjunto: '',
        fk_idCatSemaforoResultado: null,
      },

      file: null,

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('expediente', {
      expediente: 'getExpedientesPersonal',
    }),

    ...mapGetters('semaforoResultado', {
      semaforoResultado: 'getSemaforoResultado',
    }),

    activeStepTitle() {
      switch (this.activeStep) {
        case 1:
          return 'Oficio de validación';
        case 2:
          return 'Resultado';
        default:
          return '';
      }
    },

    validActiveStep() {
      switch (this.activeStep) {
        case 1:
          if (this.validacion.oficioValidacion !== '' && this.validacion.fechaOficio) {
            return true;
          } return false;
        case 2:
          if (this.resultadoForm) {
            return true;
          } return false;
        default:
          return false;
      }
    },

    activeStepButtonLabel() {
      if (this.activeStep < 2) {
        return 'Siguiente paso';
      }
      return 'Registrar evaluación';
    },
  },

  async mounted() {
    this.overlay = true;
    await this.fetchExpedienteById(this.idExpediente);
    this.overlay = false;
  },

  methods: {
    ...mapActions('evaluacionesValidacion', ['saveEvaluacionValidacion']),
    ...mapActions('expediente', ['fetchExpedienteById']),

    async activeStepButtonHandler() {
      if (this.activeStep < 2) {
        this.activeStep += 1;
      } else {
        this.loading = true;

        await this.saveEvaluacionValidacion({
          fk_idDerivacion: this.idDerivacion,
          fk_idProgramacion: this.idProgramacion,
          fk_idExpediente: this.idExpediente,
          fechaElaboracion: moment().format('DD/MM/YYYY'),
          fechaEvaluacion: moment().format('DD/MM/YYYY'),
          oficioValidacion: this.validacion.oficioValidacion,
          fechaOficio: moment(this.validacion.fechaOficio).format('DD/MM/YYYY'),
          matriculaCartilla: this.validacion.matriculaCartilla,
          resultado: this.validacion.resultado,
          observaciones: this.validacion.observaciones,
          adjunto: this.file ? this.file.name : '',
          file: this.file,
          fk_idCatSemaforoResultado: this.validacion.fk_idCatSemaforoResultado,
        });
        this.loading = false;
        this.$router.push('/investigacion_socioeconomica/validacion');
      }
    },
  },
};
</script>
